import React, { useRef, useState, useEffect } from "react";
import {
  getUserTypeList,
  updateActiveStatus,
} from "../../services/user-type.services";
import toast from "react-hot-toast";
import {
  CAvatar,
  CCard,
  CCardBody,
  CCol,
  CRow,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
  CToaster,
  CButton,
  CFormLabel,
  CFormInput,
  CFormSelect,
} from "@coreui/react";
import CIcon from "@coreui/icons-react";
import { cilPeople, cilPencil, cilPlus } from "@coreui/icons";
import CustomPagination from "../../components/CustomPagination";
import DeleteModal from "../../components/DeleteModal/DeleteModal";
import avatar1 from "src/assets/images/avatars/1.jpg";
import avatar2 from "src/assets/images/avatars/2.jpg";
import avatar3 from "src/assets/images/avatars/3.jpg";
import { Link } from "react-router-dom";
import { FaEdit } from "react-icons/fa";
import Switch from "react-switch";
import { useForm } from "react-hook-form";
import { UserTypePermissions } from "src/uitils/constants";

const UserTypeManagementTable = (props) => {
  const [visibleDeleteModal, setVisibleDeleteModal] = useState(false);
  const [count, setCount] = useState(0);
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(15);
  const [isLoading, setIsLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [userSelectedStatus, setUserSelectedStatus] = useState("");
  const [selectedPermission, setSelecPermission] = useState("");

  const { register, reset, handleSubmit } = useForm({
    defaultValues: {
      q: "",
      type: "",
      permission: "",
      isActive: "",
    },
  });

  useEffect(() => {
    getUserTypeItem(currentPage);
  }, []);

  const getUserTypeItem = (page, searchData = null) => {
    setIsLoading(true);
    let params = { page, limit, ...searchData };
    getUserTypeList(params)
      .then(async (response) => {
        setIsLoading(false);
        setCount(response.count);
        setData(response.data);
        setData(response.data);
        const totalPages = Math.ceil(response.count / limit);
        setTotalPages(totalPages);
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
      });
  };

  const [defaultErrorMessage, setDefaultErrorMessage] = useState(
    '"Something went wrong. Please try again"'
  );
  const handleStatusChange = (checked, id) => {
    const data = {
      isActive: checked,
    };
    toast
      .promise(
        updateActiveStatus(data, id),
        {
          loading: "Loading",
          success: "Status updated Succesfully",
          error: (err) => {
            return err.response &&
              err.response.data &&
              err.response.data.message
              ? err.response.data.message
              : defaultErrorMessage;
          },
        },
        {
          id: "login",
        }
      )
      .then(async (response) => {
        console.log("response", response);
        getUserTypeItem(currentPage);
      })
      .catch((error) => console.error(error));
  };

  const handlePageChange = (newPage) => {
    console.log("newPage", newPage);
    setCurrentPage(newPage);
    getUserTypeItem(newPage);
  };

  const onFormSubmit = (data) => {
    console.log(data);
    setCurrentPage(1);
    getUserTypeItem(1, data);
  };

  const handleReset = () => {
    reset({
      q: "",
      type: "",
      permission: "",
      isActive: "",
    });
    getUserTypeItem(1);
  };

  return (
    <>
      <CCard className="mb-4">
        <CCardBody>
          <CRow className="mb-4">
            <CCol xs={12} md={3}>
              <CFormLabel>Position Name</CFormLabel>
              <CFormInput
                type="text"
                placeholder="Type name"
                {...register("q", { required: false })}
              />
            </CCol>
            <CCol xs={12} md={3}>
              <CFormLabel>User Type</CFormLabel>
              <CFormSelect
                defaultValue={userSelectedStatus}
                {...register("type", { required: false })}
              >
                <option value="">All</option>
                <option value="superAdmin">Super Admin</option>
                <option value="admin">Admin</option>
                <option value="cvit">CVIT</option>
                <option value="driver">Driver</option>
                <option value="store">Store</option>
                <option value="others">Others</option>
              </CFormSelect>
            </CCol>
            <CCol xs={12} md={3}>
              <CFormLabel>Permission</CFormLabel>
              <CFormSelect
                defaultValue={selectedPermission}
                {...register("permission", { required: false })}
              >
                <option value="">All</option>
                {UserTypePermissions.map(({ value, label }, index) => (
                  <option value={value} key={index}>
                    {label}
                  </option>
                ))}
              </CFormSelect>
            </CCol>
            <CCol xs={12} md={3}>
              <CFormLabel>Status</CFormLabel>
              <CFormSelect
                defaultValue={userSelectedStatus}
                {...register("isActive", { required: false })}
              >
                <option value="">All</option>
                <option value="true">Active</option>
                <option value="false">Inactive</option>
              </CFormSelect>
            </CCol>
          </CRow>

          <div className="d-flex justify-content-end mt-3">
            <CButton
              type="submit"
              color="primary"
              className="px-5 py-2 me-3"
              onClick={handleSubmit(onFormSubmit)}
            >
              Submit
            </CButton>
            <CButton
              type="submit"
              className="px-5 py-2 ms-3 btn-oliveGreen"
              onClick={handleReset}
            >
              Reset
            </CButton>
          </div>
        </CCardBody>
      </CCard>
      <CCard className="mb-4">
        <CCardBody>
          <CRow>
            <CCol sm={5}>
              <h4 id="traffic" className="card-title mb-0">
                User Type Management
              </h4>
            </CCol>
            <CCol sm={7} className="d-none d-md-block">
              <div className="d-flex justify-content-end">
                <Link to="/create-user-type">
                  <CButton>
                    <CIcon icon={cilPlus} />
                    &nbsp; Create
                  </CButton>
                </Link>
              </div>
            </CCol>
          </CRow>
          <br />
          <CTable align="middle" className="mb-0 border" hover responsive>
            <CTableHead color="light">
              <CTableRow>
                <CTableHeaderCell>Active Status</CTableHeaderCell>
                <CTableHeaderCell>Action</CTableHeaderCell>
                {/* <CTableHeaderCell className="text-center">
                  <CIcon icon={cilPeople} />
                </CTableHeaderCell> */}
                <CTableHeaderCell>Position Name</CTableHeaderCell>
                <CTableHeaderCell>User Type</CTableHeaderCell>
                <CTableHeaderCell>Permission</CTableHeaderCell>
              </CTableRow>
            </CTableHead>
            <CTableBody>
              {isLoading ? (
                <CTableRow className="text-center">
                  <CTableDataCell colSpan="5">Loading...</CTableDataCell>
                </CTableRow>
              ) : data.length == 0 ? (
                <CTableRow className="text-center">
                  <CTableDataCell colSpan="5">No data available</CTableDataCell>
                </CTableRow>
              ) : (
                data.map((item, index) => (
                  <CTableRow v-for="item in tableItems" key={index}>
                    <CTableDataCell>
                      <Switch
                        onChange={(checked, id) =>
                          handleStatusChange(checked, item._id)
                        }
                        checked={item.isActive}
                      />
                    </CTableDataCell>
                    <CTableDataCell>
                      <Link to={`/edit-user-type/${item._id}`}>
                        <CButton color="secondary" style={{ color: "white" }}>
                          <FaEdit />
                        </CButton>
                      </Link>

                      {/* {
                        item.action!=1?<FaEdit />:''
                      } */}
                    </CTableDataCell>
                    {/* <CTableDataCell className="text-center">
                    <CAvatar
                      size="md"
                      src={avatar1}
                      status="success"
                    />
                  </CTableDataCell> */}
                    <CTableDataCell className="text-capitalize">
                      <div>{item.name}</div>
                    </CTableDataCell>
                    <CTableDataCell className="text-capitalize">
                      <div>{item.type}</div>
                    </CTableDataCell>
                    <CTableDataCell>
                      {Object.entries(item.permission).map(([key, value]) => (
                        <span key={key}>
                          {key}: {value.toString()},
                        </span>
                      ))}
                    </CTableDataCell>
                  </CTableRow>
                ))
              )}
            </CTableBody>
          </CTable>
          <br />
          <CustomPagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        </CCardBody>
      </CCard>
      {/* <DeleteModal
        visible={visibleDeleteModal}
        setVisibleDeleteModal={setVisibleDeleteModal}
        addToast={addToast}
      />
      <CToaster ref={toaster} push={toast} placement="top-end" /> */}
    </>
  );
};

export default UserTypeManagementTable;
